import { render, staticRenderFns } from "./ad_space_set.vue?vue&type=template&id=58831141&scoped=true"
import script from "./ad_space_set.vue?vue&type=script&lang=js"
export * from "./ad_space_set.vue?vue&type=script&lang=js"
import style0 from "./ad_space_set.vue?vue&type=style&index=0&id=58831141&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58831141",
  null
  
)

export default component.exports